import BigquerySourceIcon from "../../assets/components/sources/BigquerySourceIcon";

const GoogleBigqueryLogomark = ({ height }: { height: number }) => {
  return <BigquerySourceIcon height={height} />;
};

export default GoogleBigqueryLogomark;
